<template>
  <Head title="Registro" />
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-100 to-blue-200 p-4">
    <div class="w-full max-w-4xl">
      <!-- Logo -->
      <logo 
        class="block mx-auto w-full max-w-xs fill-blue-600 transition-transform hover:scale-105" 
        height="50"
      />

      <!-- Registration Form -->
      <form 
        @submit.prevent="register" 
        class="mt-8 bg-white rounded-2xl shadow-2xl overflow-hidden transition-all duration-300 hover:shadow-3xl"
      >
        <div class="px-10 py-12">
          <!-- Header -->
          <h1 class="text-center text-3xl font-bold text-gray-800">
            Crear nueva cuenta
          </h1>
          <p class="text-center text-gray-600 mt-2">
            Complete la información para registrarse
          </p>
          <div class="mt-6 mx-auto w-24 border-b-2 border-blue-500" />

          <!-- Form Fields -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            <!-- Account Information -->
            <div class="space-y-6">
              <h2 class="font-semibold text-lg text-gray-700 border-b pb-2">Información de la Empresa</h2>
              
              <text-input
                v-model="form.company.name"
                :error="form.errors['company.name']"
                label="Nombre de la Empresa *"
                placeholder="Nombre de su empresa"
              />

              <text-input
                v-model="form.company.identification"
                :error="form.errors['company.identification']"
                label="RIF *"
                placeholder="J-12345678-9"
              />

              <text-input
                v-model="form.company.email"
                :error="form.errors['company.email']"
                type="email"
                label="Email Corporativo *"
                placeholder="empresa@ejemplo.com"
              />

              <text-input
                v-model="form.company.phone"
                :error="form.errors['company.phone']"
                label="Teléfono"
                placeholder="+58 412-1234567"
              />

              <text-input
                v-model="form.company.reasonName"
                :error="form.errors['company.reasonName']"
                label="Razón Social"
                placeholder="Razón social de la empresa"
              />

              <text-input
                v-model="form.company.address"
                :error="form.errors['company.address']"
                label="Dirección"
                placeholder="Dirección de la empresa"
              />
            </div>

            <!-- User Information -->
            <div class="space-y-6">
              <h2 class="font-semibold text-lg text-gray-700 border-b pb-2">Información del Usuario</h2>
              
              <text-input
                v-model="form.user.first_name"
                :error="form.errors['user.first_name']"
                label="Nombre *"
                placeholder="Su nombre"
              />

              <text-input
                v-model="form.user.last_name"
                :error="form.errors['user.last_name']"
                label="Apellido *"
                placeholder="Su apellido"
              />

              <text-input
                v-model="form.user.email"
                :error="form.errors['user.email']"
                type="email"
                label="Email Personal *"
                placeholder="usuario@ejemplo.com"
              />

              <text-input
                v-model="form.user.password"
                :error="form.errors['user.password']"
                type="password"
                label="Contraseña *"
                placeholder="Mínimo 8 caracteres"
              />

              <text-input
                v-model="form.user.password_confirmation"
                :error="form.errors['user.password_confirmation']"
                type="password"
                label="Confirmar Contraseña *"
                placeholder="Repita su contraseña"
              />
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="px-10 py-6 bg-gray-50 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link 
            href="/login"
            class="text-sm text-gray-600 hover:text-gray-800"
          >
            ¿Ya tiene una cuenta? Inicie sesión
          </Link>
          
          <loading-button
            :loading="form.processing"
            class="btn-blue text-lg font-medium w-full sm:w-auto"
            type="submit"
          >
            {{ form.processing ? 'Registrando...' : 'Crear cuenta' }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'Register',
  
  components: {
    Head,
    Link,
    LoadingButton,
    Logo,
    TextInput,
  },

  data() {
    return {
      form: this.$inertia.form({
        company: {
          name: '',
          identification: '',
          email: '',
          phone: '',
          reasonName: '',
          address: '',
        },
        user: {
          first_name: '',
          last_name: '',
          email: '',
          password: '',
          password_confirmation: '',
          role: 'admin', // Default role for first user
        }
      })
    }
  },

  methods: {
    register() {
      this.form.post('/register', {
        onSuccess: () => {
          // Will automatically redirect to dashboard
        },
        onError: () => {
          // Errors will be displayed in the form
        }
      })
    },
  },
}
</script>